import { render } from "./ModalTransporterStop.vue?vue&type=template&id=5d18efb9"
import script from "./ModalTransporterStop.vue?vue&type=script&lang=js"
export * from "./ModalTransporterStop.vue?vue&type=script&lang=js"

import "./ModalTransporterStop.vue?vue&type=style&index=0&id=5d18efb9&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__